import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons';

/**
 * A one-time soft nudge encouraging users to enable 2FA. Resolves with `true` if
 * the user chooses to set it up now, `false` otherwise.
 *
 * Two variants: a generic security suggestion, or — when enforcement is already
 * scheduled for the user's cohort — a heads-up naming the date, so they can enrol
 * before the deadline rather than being interrupted by it.
 */
@Component({
  selector: 'app-mfa-prompt-modal',
  standalone: false,
  templateUrl: './mfa-prompt-modal.component.html',
  styleUrls: ['./mfa-prompt-modal.component.scss'],
})
export class MfaPromptModalComponent {
  /** Epoch ms at which enforcement begins for this user, when already scheduled. */
  @Input() requiredFrom: number | null = null;

  faShieldHalved = faShieldHalved;

  get isScheduled(): boolean {
    return typeof this.requiredFrom === 'number';
  }

  constructor(public activeModal: NgbActiveModal) {}

  setUpNow(): void {
    this.activeModal.close(true);
  }

  maybeLater(): void {
    this.activeModal.close(false);
  }
}
